const sh = require('shelljs')
const { config, error } = require('../common.js')
const { name } = require('../../package.json')

module.exports = yargs => {

	const { stderr } = sh.exec(
		`cd ${config.get("ops_client_path")}/node_modules/@leiops/icon && open ./docs/index.html`
	)
}




// WEBPACK FOOTER //
// ./src/commands/icons.js